import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChatroomComponent } from './ui/chatroom/chatroom.component';
import { HomeComponent } from './ui/home/home.component';

const routes: Routes = [
  { path: ':token', component: ChatroomComponent },
  { path: '**', component: HomeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
